import { css } from '@emotion/react';

export const progressWrap = css`
  padding: 16px 8px;
`;

export const bar = ({ color }) => `
  background-color: ${color.primary};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100px;
`;

export const bullets = {
  margin: 'auto',
};

export const bullet =
  ({ current, past, next }) =>
  ({ color }) =>
    [
      `
    background-color: ${color.white};
    border-radius: 50%;
    font-size: 18px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 32px; 
  `,
      past &&
        `
    background-color: ${color.primary};
    color: ${color.white};
  `,
      current &&
        `
    transform: scale(1.16);
  `,
      next &&
        `
    background-color: ${color.gray};
    color: ${color.gray2};
  `,
    ];

export const overlay = ({ color, media }) => `
  border-top: 1px solid ${color.primary};
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background-color: ${color.black};
  padding: 0 16px;
  top: 40px;
  overflow: auto;
  ${media.phone} {
    top: 40px;
  }
`;

export const progressBG = ({ color }) => `
  background-color: ${color.white};
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  height: 8px;
`;
